// extracted by mini-css-extract-plugin
module.exports = {"links":"SearchLinkSection_links__16e_J","link":"SearchLinkSection_link__3LeB_","active":"SearchLinkSection_active__3NS7-"};